import React, { FC } from 'react';
import { useTranslations } from '@lang';
import { ReduxFormSelect } from '../../../FormElements/BlockSelectField';
import { GuestSelectorComponentProps } from '../sharedTypes';

export const GuestSelector: FC<GuestSelectorComponentProps> = ({ input, options, ...rest }) => {
  const { t } = useTranslations();

  return (
    <ReduxFormSelect
      placeholder={t('spa.extrasSelectGuestsCTA')}
      isSearchable={false}
      isClearable={false}
      labelWidth="0"
      isMulti
      useNativeDropdownOnMobile={false}
      ctaLabel={t('spa.extrasSelectGuestsCTA')}
      input={input}
      options={options}
      {...rest}
    />
  );
};
